<template>
  <div class="webhook-settings">
    <configure-webhook v-if="getterPopupName === 'ConfigureWebhook'"
                      :webhookOptions="webhookOptions"
                      @refreshWebhook="populateData" />
    <toggle-webhook v-else-if="getterPopupName === 'ToggleWebhook'"
                    :webhookOptions="webhookOptions"
                    @refreshWebhook="populateData" />

    <h5>Webhook Settings</h5>

    <div v-for="(data, index) in webhooks" :key="index" class="webhooks-list">
      <b>{{data.text}}</b>
      <p>{{data.status}}</p>
      <div class="actions">
        <span v-for="(option, actionIndex) in data.actions" :key="actionIndex"
              :class="option.css" @click="option.execute(data)">
          <i class="fa" :class="option.icon" />{{option.text}}
        </span>
      </div>
    </div>

    <table-loader v-if="!webhooks.length" :css="{'border-layout': !isDesktop()}" />
  </div>
</template>

<script>
import ConfigureWebhook from '@/components/Settings/Webhooks/ConfigureWebhook'
import ToggleWebhook from '@/components/Settings/Webhooks/ToggleWebhook'
import TableLoader from '@/components/global/TableLoader'

import ApiServices from '@/services/api/webhooks'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'SettingsWebhook',
  components: { ConfigureWebhook, ToggleWebhook, TableLoader },
  data () {
    return {
      webhooks: [],
      webhookOptions: {},
      edit: {
        css: 'edit',
        icon: 'fa-pencil-alt',
        text: 'Edit',
        execute: (data) => this.configureType(data, 'Update')
      },
      enable: {
        css: 'enable',
        icon: 'fa-check',
        text: 'Enable',
        execute: (data) => this.toggleWebhook(data, 'Enable')
      },
      disable: {
        css: 'disable',
        icon: 'fa-times',
        text: 'Disable',
        execute: (data) => this.toggleWebhook(data, 'Disable')
      },
      configure: {
        css: 'configure',
        icon: 'fa-wrench',
        text: 'Configure',
        execute: (data) => this.configureType(data, 'Configure')
      }
    }
  },
  created () {
    this.populateData()
  },
  computed: {
    ...mapGetters(['getterPopupName'])
  },
  methods: {
    ...mapMutations(['SET_POPUP_NAME']),
    populateData () {
      ApiServices.webhooksList().then((response) => {
        let data = response.data
        if (data) {
          this.webhooks = data.map(entry => {
            entry.actions = []
            switch (entry.status) {
              case 'NOT_CONFIGURED': entry.actions.push(this.configure)
                break
              case 'ENABLED': entry.actions.push(this.edit, this.disable)
                break
              case 'DISABLED': entry.actions.push(this.edit, this.enable)
                break
              case 'BLOCKED': entry.actions.push(this.edit, this.disable, this.enable)
                break
            }
            return entry
          })
        }
      })
    },
    configureType (data, type) {
      data['type'] = type
      data['title'] = `${type} ${data.text} Webhook`
      this.webhookOptions = data
      this.SET_POPUP_NAME('ConfigureWebhook')
    },
    toggleWebhook (data, type) {
      data['type'] = type
      data['title'] = `${type} Webhook`
      this.webhookOptions = data
      this.SET_POPUP_NAME('ToggleWebhook')
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .webhook-settings {
    text-align: left;

    h5 {
      @include highlight-text($secondary, 18px);
      margin-bottom: 10px;
    }

    .webhooks-list {
      @include custom-flex(flex-start, null);
      padding: 20px 0;
      border-bottom: $divider;

      b {
        flex: 1;
        @include highlight-text($secondary, 13px);
        margin-right: 10px;
      }
      p {
        flex: 1;
        @include normal-text($secondary, 13px);
      }
      .actions {
        display: flex;
        flex-wrap: wrap;
        grid-gap: 15px;
        flex: 2;

        span {
          font-size: 13px;
          font-weight: bold;
          cursor: pointer;
          padding: 7px 15px;
          border: 1px solid #e4e7e7 !important;
          border-radius: 10px;
          white-space: nowrap;

          i {
            margin-right: 10px;
          }

          &.edit {
            color: $grey-text;
          }
          &.disable {
            color: $decrease;
          }
          &.enable {
            color: $increase;
          }
          &.configure {
            color: $secondary;
          }
        }
      }
    }
  }

  .desktop {
    .webhooks-list {
      .actions {
        justify-content: flex-end;
      }
    }
  }

  .mobile, .tablet {
    .webhooks-list {
      display: block;

      .actions {
        margin-top: 10px;
      }

      b {
        display: inline;
        font-size: 16px;
      }
      p {
        float: right;
      }
    }
  }
</style>
